import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePhone } from '@fortawesome/pro-light-svg-icons';
import './maintenance.scss';

export default function Maintenance() {
    const [siteConfig] = useState(JSON.parse(localStorage.getItem('siteConfig') || "{}"))
    return (
        <div className="maintenance-container">
            <div className="maintenance-message">
                <img
                    className="maintenance-image"
                    src={require(`../assets/maintenance_${siteConfig.activeSite}.jpg`)}
                />
                <h1>Website Under Maintenance</h1>
                <p>
                    This website is currently undergoing scheduled maintenance. We should be back shortly.
                </p>
            </div>
        </div>
    )
}